import { Components, Theme, ThemeOptions } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const getSelectTheme = (theme: Theme): ThemeOptions => {
  const selectTheme: Components<Theme>['MuiSelect'] = {
    defaultProps: {
      IconComponent: ExpandMoreIcon,
    },
    styleOverrides: {
      root: {
        // M3/body/large typography for value text
        ...theme.typography.M3.body.large,
        borderRadius: theme.unit(2), // 8px
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.M3.sys.light.outline,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.M3.sys.light.outline,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.M3.sys.light.primary,
        },
      },
      select: {
        ...theme.typography.M3.body.large,
        '&.MuiInputLabel-shrink': {
          padding: theme.unit(0, 0, 0, 42),
        },
        display: 'flex',
        alignItems: 'center',
      },
      icon: {
        right: theme.unit(2), // 8px from right edge (icon box padding)
        color: theme.palette.M3.sys.light['on-surface-variant'],
      },
    },
  };

  return {
    components: {
      MuiSelect: selectTheme,
    },
  };
};

export default getSelectTheme;
